var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[_c('h1',[_vm._v(_vm._s(_vm.$t('delete_account')))]),_c('p',[_vm._v(_vm._s(_vm.$t('email'))+": "+_vm._s(_vm.user ? _vm.user.email : ""))]),_c('button',{on:{"click":_vm.deleteAccount}},[_vm._v(_vm._s(_vm.$t('delete_account')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }